import bFormGroup from 'bootstrap-vue/es/components/form-group/form-group';

const FOCUSED_CLASS = 'focused';

/**
 *
 * @type {{name: string, extends: {mixins, components, render, props, computed, watch, methods, mounted}, data(): *, computed: {stateClass(): *}, methods: {addListeners(): void, focus(): void, blur(*): void}, beforeMount(): void, mounted(): void}}
 */
var pyFormGroup = {
  name: 'pyFormGroup',
  extends: bFormGroup,
  data: function(){
    return {
      stateClassObj: {
        error: false,
        focused: false,
        hasValue: false
      }
    }
  },
  computed: {
    stateClass: function(){
      return this.stateClassObj
    }
  },
  methods: {
    // Listen for events from input
    addListeners: function() {
      this.$on("pyInputBlur", function(field){
        this.blur(field)
        this.$parent.$emit('pyInputBlur', field);
      })

      this.$on("pyInputChange", function(field){
        this.$parent.$emit('pyInputChange', field);
      })

      this.$on("pyInputFocus", function(field){
        this.focus()
        this.$parent.$emit('pyInputFocus', field);
      })


    },
    // Add the focus class on the form group to transition the label to the label position
    focus: function() {
      this.stateClassObj.focused = true
    },
    // Remove the focus class on the form group to transition the label to the placeholder position
    blur: function(field) {
      this.stateClassObj.focused = false
      this.stateClassObj.hasValue = (field.value != '') ? true : false
    }
  },
  beforeMount: function(){
    //set a class on form group
    this.$on("pyAddClassToParent", function(val){
      this.stateClassObj[val] = true
    })

  },
  mounted: function() {
    this.addListeners()
  }
};

export default pyFormGroup;
